import { render, staticRenderFns } from "./ProjectTaskActivitiesItem.vue?vue&type=template&id=5b1dde5f&scoped=true&"
import script from "./ProjectTaskActivitiesItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProjectTaskActivitiesItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1dde5f",
  null
  
)

export default component.exports